import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key: "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key: "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key: "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
  {
    key: "CITY-CODE",
    value: '{{CITY-CODE}}',
    required: true
  },
];
const QueryData: any = [
  {
    param: "limit",
    value: '{{limit}}',
    required: false
  },
  {
    param: "offset",
    value: '{{offset}}',
    required: false
  },
  {
    param: "filter",
    value: '{{filter}} Filter value in json format e.g.',
    code: `{
    "property_uid": "",
    "unit_uid": "",
    "transaction_uid":"",
    "entity_type": "",
    "outlier": "",
    "transaction_value": "",
    "transaction_area": "",
    "date": "",
    "transaction_date": "",
}`,
    required: false
  }
]
@Component({
  selector: 'app-dallal-transaction',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    RouterModule,
    ApiTitleComponent,
    ApiUIResponseComponent,],
  templateUrl: './dallal-transaction.component.html'
})
export class DallalTransactionComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService,
    private userService: UserService,
    private router: Router) {

  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.userService.getAllUserResource(userInfo.user_id)
      .subscribe({
        next: (res: any) => {
          const matched = res.data.find((r: any) => r.resource_name === Resource.Transaction);
          if (!matched?.methods?.includes(HTTPMethod.GET)) {
            this.router.navigate(['/'])
          }
        },
        error: (err) => {
        }
      })
  }

  ngAfterViewInit() {
  }

  api_demo = `${environment.apiBaseUrl}${apiEndPoints.transactions}`;

  api_response = `
{
    "status": 200,
    "message": "Result found!",
    "data": [
        {
            "transaction_uid": "TSTTA14J68",
            "property_uid": "TSTLA00000",
            "unit_uid": "TSTUA00223",
            "entity_type": "unit",
            "transaction_value": 7321093,
            "transaction_area": 752,
            "date": "trans_auction",
            "start_date": "2025-01-01",
            "outlier": false,
            "end_date": "2025-12-31"
        }
    ]
}`;
}

